import { get } from '~/utils/ajax';
import { settings } from '~/utils/settings';
import { SessionStorageHelper } from '~/utils/storage';

type ContentStateType = {
    coupons: ICoupon[];
    bundles: IBundleList;
    bundlesPrerequisitesHash: string;
};
const BUNDLE_PREREQUISITES_HASH_KEY = 'bundlesPrerequisitesHash';
export async function syncContentState(): Promise<ContentStateType> {
    const hash = SessionStorageHelper.get(BUNDLE_PREREQUISITES_HASH_KEY);
    const response = await get(settings.urls.contentStateSyncUrl + (!!hash ? `?bundlesPrerequisitesHash=${hash}` : ''));
    if (response.bundlesPrerequisitesHash && response.bundlesPrerequisitesHash !== hash) {
        SessionStorageHelper.set(BUNDLE_PREREQUISITES_HASH_KEY, response.bundlesPrerequisitesHash);
    }
    return response;
}
